import { Component, OnInit } from '@angular/core';
import { AccountService } from '@supoui/core/auth/account.service';
import { ModalDialogConfiguration } from '@supoui/shared/model/modal/modal-dialog-configuration';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-send-form-success-modal',
  templateUrl: './send-form-success-modal.component.html',
  styleUrls: ['./send-form-success-modal.component.scss'],
  standalone: false
})
export class SendFormSuccessModalComponent implements OnInit {
  modalDialogConfiguration: ModalDialogConfiguration;

  constructor(private accountService: AccountService, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.modalDialogConfiguration = new ModalDialogConfiguration({
      header: `SMS sent to patient`,
      isCrossClose: false,
      yesLabel: 'OK',
      isYes: true,
      isNo: false,
      isClose: false
    });
  }

  closeModalEvent(event: boolean): void {
    if (event) {
      this.activeModal.close(event);
    }
  }
}
